import { EditorSections } from '@/pages/webhooks/components/types';
import { PageTypes } from '@/store/application/page.definitions';
import { EpisodeTypesMap, ObjectsTypesMap } from '@/store/application/data.assets';
import { getEventFiltersBuilder } from '@/pages/events/forms/EventFiltersBuilder';
import { getCounterRecordFilters } from '@/pages/counters/counterFiltersBuilder';

export function webhooksFiltersEditorVisualBuilder(options = { small: false }) {
  return {
    [EditorSections.FaceEvents]: getEventFiltersBuilder(options, true).getFilterByType(PageTypes.Events, ObjectsTypesMap.Faces, ''),
    [EditorSections.BodyEvents]: getEventFiltersBuilder(options, true).getFilterByType(PageTypes.Events, ObjectsTypesMap.Bodies, ''),
    [EditorSections.CarEvents]: getEventFiltersBuilder(options, true).getFilterByType(PageTypes.Events, ObjectsTypesMap.Cars, ''),
    [EditorSections.HumanEpisodes]: getEventFiltersBuilder(options, true).getFilterByType(PageTypes.Episodes, '', EpisodeTypesMap.Humans),
    [EditorSections.CarEpisodes]: getEventFiltersBuilder(options, true).getFilterByType(PageTypes.Episodes, '', EpisodeTypesMap.Cars),
    [EditorSections.Counters]: getCounterRecordFilters({ small: options.small }, [], true)
  };
}
